import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { businessInfo } from '../mockData';
import { posts } from '../content/blog';
import usePageMeta from '../hooks/usePageMeta';

const Blog = () => {
  usePageMeta();
  return (
    <div className="min-h-screen">
      <section className="relative bg-gray-950 py-16 sm:py-20 text-white overflow-hidden">
        <div className="absolute inset-y-0 right-0 w-full md:w-3/5" aria-hidden="true">
          <img src="/images/stock/cover-lock-wooden-door.jpg" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/50 to-gray-950/5"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-bold mb-5">Locksmith tips &amp; guides</h1>
            <p className="text-xl text-gray-300">
              Straight answers from a North Shore locksmith — costs, lockouts, home security and more.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {posts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="block group">
                <Card className="border-gray-200 h-full group-hover:border-red-300 group-hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-7 flex flex-col h-full">
                    <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-2">{post.date}</p>
                    <h2 className="text-xl font-bold text-gray-900 mb-3">{post.title}</h2>
                    <p className="text-gray-600 flex-1">{post.excerpt}</p>
                    <span className="text-red-600 font-semibold text-sm flex items-center gap-1 mt-4">
                      Read more <ArrowRight size={15} />
                    </span>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 bg-gray-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-3">Need a locksmith, not an article?</h2>
          <p className="text-lg text-gray-300 mb-7">Mobile across the North Shore, fixed quotes before any work.</p>
          <a href={`tel:${businessInfo.phoneTel}`}>
            <Button size="lg" className="bg-red-600 text-white hover:bg-red-700 font-bold">
              <Phone className="mr-2" size={20} />
              Call {businessInfo.phone}
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Blog;
